import React, { useMemo } from "react"
import { Button, Typography } from "@material-ui/core"
import ImportExportIcon from "@material-ui/icons/ImportExport"
import * as FileSaver from "file-saver"
import { pick } from "lodash"
import { Parser } from "json2csv"

import PropTypes from "prop-types"
import formatNumberWithCommas from "../../../../../utils/formatNumberWithCommas"
import moment from "../../../../../../node_modules/moment/moment"

const ExportCsvButton = ({ data = [], fields = [], tab }) => {
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  const shootRequiredFields = [
    "shoot_id",
    "client_company",
    "shoot_name",
    "income",
    "expense",
    "total",
    "outstandingBalance",
    "paid_date",
  ]

  const crewRequiredFields = [
    "total_earned",
    "outstanding_balance",
    "paid_amount",
    "shoot_id",
    "shoot_name",
    "client_company",
  ]

  const gttRequiredFields = [
    "commission_billable",
    "commission_cost",
    "commission_net",
    "shoot_id",
    "shoot_name",
  ]

  const invoiceFrom = {
    gtt: "Go To Team",
    adesk: "Assignment Desk",
    crewmama: "Crew Mama",
    mcs: "Media Content Services",
  }

  let dataToBeExported = useMemo(
    () => {
      if (tab === "shoots") {
        let shootData = data.map(item => {
          return {
            ...pick(item, shootRequiredFields),
            crewmama_or_gtt: invoiceFrom[item.crewmama_or_gtt],
            shoot_end_date: moment(item.shoot_end_date).format("MM/DD/YY"),
            paid_date: moment(item.paid_date).format("MM/DD/YY"),
            clientPay: item.clientPay ? item.clientPay : 0,
            add_amount: item.add_amount ? item.add_amount : 0,
          }
        })
        return shootData
      }
      if (tab === "crew") {
        let crew = data.map(item => {
          let clientPaid =
            (item.clientFirstPaid && item.clientSecondPaid) ||
            item.clientFullPaid
              ? "Paid"
              : item.clientFirstPaid && !item.clientSecondPaid
                ? "Deposit Paid"
                : "Not Paid"

          return {
            ...pick(item, crewRequiredFields),
            user_name: item.hasOwnProperty("shoot_name") ? "" : item.user_name,
            client_paid: clientPaid,
            shoot_date: moment(item.shoot_date).format("MM/DD/YY"),
          }
        })
        return crew
      }
      if (tab === "gtt") {
        let gtt = data.map(item => {
          return {
            ...pick(item, gttRequiredFields),
            user_name: item.hasOwnProperty("shoot_name") ? "" : item.user_name,
            commission_net: item.hasOwnProperty("commission_net")
              ? item.commission_net
              : "",
          }
        })
        return gtt
      }
    },
    [data]
  )

  function exportFile() {
    const opts = { fields }
    try {
      const parser = new Parser(opts)
      const csv = parser.parse(dataToBeExported)
      var file = new Blob([csv], { type: "text/csv" })
      if (tab === "shoots") {
        FileSaver.saveAs(file, `ShootBillingData.csv`)
      } else if (tab === "crew") {
        FileSaver.saveAs(file, `CrewBillingData.csv`)
      } else if (tab === "gtt") {
        FileSaver.saveAs(file, `GttBillingData.csv`)
      }
    } catch (err) {
      console.log("Error", err)
      //   dispatch(openSnackBar({ message: "Error downloading expense data" }))
    }
  }

  return (
    <Button
      onClick={exportFile}
      style={{ marginRight: "10px", marginLeft: "10px" }}
    >
      <ImportExportIcon
        style={viewportWidth > 600 ? {} : { fontSize: "20px" }}
      />
      <Typography
        style={
          viewportWidth > 600
            ? { fontSize: "18px", fontWeight: 550 }
            : { fontSize: "15px", fontWeight: 550 }
        }
      >
        Export All
      </Typography>
    </Button>
  )
}

ExportCsvButton.propType = {
  data: PropTypes.array,
}

export default ExportCsvButton
